export enum TuffexProductCatalogueWorkspaceCapabilityAccessOperation {
    create = "6e0e5e38-4289-424d-855d-ba0ec6e58e15",
    read = "c2a68d56-ab7c-4dd8-9f9e-ea3bb3d5baa9",
    update = "11cb7a00-24c7-4884-87b6-a8d4728eec61",
    delete = "53284699-d01a-4536-a060-cad719cdb031",
}
